const en = {
  "nav": [
    "Pricing",
    "References",
    "FAQ",
    "Contact"
  ],
  "navCta": "Get Free Design",
  "heroBadge": "🔥 Limited Offer — 50% off until the end of the month",
  "heroTitle": "We build websites designed to bring in new customers",
  "heroSub": "Modern design + SEO so customers find you on Google.\nLive from 3 business days.",
  "heroBenefits": [
    "Design engineered to turn casual visitors into paying leads",
    "Blazing-fast loading speeds and flawless mobile performance",
    "Fully fully-featured: Contact forms, maps, and seamless integrations",
    "Advanced SEO setup so your local customers can find you on Google",
    "Ultra-fast 3-day delivery with zero endless delays"
  ],
  "heroCta": "Get My Free Website Concept",
  "navOrder": "Order",
  "heroMicro": "first visual draft in 24 hours · 100% risk-free · see how to grow your sales",
  "marketTag": "🌍 Websites for businesses in Europe · UK · worldwide",
  "marketTagShort": "🌍 Websites for EU · UK · worldwide",
  "problemLabel": "Where Are You Losing Money?",
  "problemTitle": "Why do most small business websites just sit online without making a single cent?",
  "problemPoints": [
    "Your current website looks outdated and drives potential clients straight away",
    "The layout breaks on mobile, loads too slowly, or feels frustrating to use",
    "You are invisible on Google — all the high-intent calls and emails go to your competitors",
    "The design lacks authority, making customers second-guess your professionalism",
    "Agencies charge you thousands upfront with absolutely zero performance guarantees"
  ],
  "problemClose": "The Result: Your competition keeps growing while you lose dozens of high-value leads every month.",
  "agitTitle": "Every single day with a weak website is a free gift to your competition",
  "agitText": "A pretty website isn't enough. If your website doesn't bring you calls and bookings, it's money thrown away. We build every website around what your future customers need.",
  "solutionLabel": "Our Process",
  "solutionTitle": "From a quick form submission to a client-catching machine from 3 business days",
  "solutionSteps": [
    {
      "num": "01",
      "title": "Risk-Free Inquiry",
      "desc": "Select your goals, tell us briefly about your business, and submit a 60-second form."
    },
    {
      "num": "02",
      "title": "Concept in 24 Hours",
      "desc": "We build and deliver an initial visual and strategic homepage draft completely free of charge."
    },
    {
      "num": "03",
      "title": "Refining Details",
      "desc": "If you love the direction, we polish the copy, structure, and features to align with your vision."
    },
    {
      "num": "04",
      "title": "Launch from 3 Days",
      "desc": "We put the site live on your domain, set up a simple overview of how many people visit it, and hand over all the keys."
    }
  ],
  "pricingLabel": "Transparent Pricing",
  "pricingTitle": "Invest in a high-performing digital asset that pays for itself",
  "pricingNote": "No hidden fees, no locked contracts. Choose the package that matches your immediate growth goals.",
  "orderBtn": "Select Package & Get Free Draft →",
  "cards": [
    {
      "tag": "Starter",
      "badge": null,
      "name": "Business Card Website",
      "price": "149 €",
      "old": "regularly 299 €",
      "forWhom": "Perfect for freelancers, local services, and tradesmen",
      "features": [
        "High-conversion layout on one high-impact page",
        "100% responsive optimization for smartphones and tablets",
        "Direct click-to-call, email, and interactive map setups",
        "WhatsApp and Messenger integration for instant customer chat",
        "Essential local SEO optimization for localized search terms",
        "Fully GDPR & privacy compliant (cookie consent banner)",
        "BONUS: Free Google Business Profile setup or expert audit",
        "Complete delivery and handover from 3 business days"
      ],
      "featured": false,
      "dark": false
    },
    {
      "tag": "Growth",
      "badge": "Most Popular",
      "name": "Business Website",
      "price": "499 €",
      "old": "regularly 999 €",
      "forWhom": "Best value for established companies looking to dominate local markets",
      "features": [
        "Everything in the Starter package +",
        "Up to 5 fully custom-designed pages (Services, About Us, etc.)",
        "Clean project gallery and organized client testimonials section",
        "We find out what your customers type into Google and set up your site so you show up for them",
        "See how many people called or messaged you from your website",
        "Complete delivery and handover within 5 business days"
      ],
      "featured": true,
      "dark": false
    },
    {
      "tag": "Performance",
      "badge": "Sales Machine",
      "name": "Full E-Commerce Store",
      "price": "999 €",
      "old": "regularly 1,999 €",
      "forWhom": "For ambitious brands ready to sell products and scale revenue online",
      "features": [
        "Everything in the Business package +",
        "Fully scalable e-commerce engine hosting up to 500 products",
        "Secure payment gateways integration (Stripe, Cards, Apple Pay)",
        "Automated PDF invoicing and real-time inventory management",
        "Intuitive dashboard for tracking orders and customer data",
        "Complete delivery and handover within 14 business days"
      ],
      "featured": false,
      "dark": true
    }
  ],
  "featuredBadge": "Recommended",
  "reviewsLabel": "Our Work Speaks for Itself",
  "reviewsTitle": "Take a look at a recently launched project",
  "riskTitle": "Risk-free collaboration",
  "riskText": "We back our code and strategy entirely. You don’t risk a single euro upfront. We build the first concept at our own expense—you only move forward if you love it.",
  "riskPoints": [
    "✓ Initial visual concept delivered within 24 hours — completely FREE",
    "✓ We sign a contract first — you pay the deposit only when you're 100% happy with the concept",
    "✓ Clear plan and communication with zero technical jargon",
    "✓ No hidden fees or long-term commitments"
  ],
  "finalCtaTitle": "Ready to own a website that works as hard as you do?",
  "finalCtaSub": "Don't let your competitors capture all the market traffic. Fill out the form and get your concept tomorrow.",
  "finalCtaBtn": "Get My Free Strategy & Draft →",
  "stickyCtaBtn": "Get a Business Card Website from 149 € →",
  "formLabel": "Quick Inquiry",
  "formTitle": "Get a professional website concept within 24 hours free",
  "formSub": "Share a few basic details. The draft is entirely non-binding — if it's not a perfect fit, you owe nothing.",
  "fields": [
    {
      "key": "name",
      "label": "Full Name *",
      "type": "text",
      "placeholder": "e.g., John Doe"
    },
    {
      "key": "email",
      "label": "Contact Email *",
      "type": "email",
      "placeholder": "john@company.com"
    },
    {
      "key": "phone",
      "label": "Phone Number *",
      "type": "tel",
      "placeholder": "+44 7123 456789"
    }
  ],
  "packageLabel": "Selected Package *",
  "packagePlaceholder": "— Choose your starting position —",
  "packages": [
    "Landing Page — 149 €",
    "Business Lead Generator — 499 €",
    "Full E-Commerce Store — 999 €"
  ],
  "intentNote": "Choose the package that best fits your current goals.",
  "intentCards": [
    {
      "value": "Landing Page — 149 €",
      "intent": "I want a clean, modern digital card",
      "sub": "I need a highly professional and fast online presence so local clients can verify my business.",
      "price": "149 €",
      "badge": null
    },
    {
      "value": "Business Lead Generator — 499 €",
      "intent": "I want to consistently sign new clients",
      "sub": "I need an asset optimized for generating quote inquiries, inbound calls, and appointment bookings.",
      "price": "499 €",
      "badge": "Best Value"
    },
    {
      "value": "Full E-Commerce Store — 999 €",
      "intent": "I want to sell products online",
      "sub": "I am looking for a fully automated, standalone online store that handles sales securely 24/7.",
      "price": "999 €",
      "badge": null
    }
  ],
  "messageLabel": "Tell us briefly about your business (optional)",
  "messagePlaceholder": "What industry are you in? What do you expect most from this website?",
  "submitBtn": "Submit Inquiry & Get Free Draft →",
  "submitting": "Processing data...",
  "successTitle": "Great, we have successfully received your inquiry!",
  "successMsg": "We have logged your inquiry. Our team is jumping straight into market analysis, and we will contact you with your custom visual layout within 24 hours.",
  "newOrder": "New Lead from Web",
  "errorMsg": "❌ The system failed to transmit the form. Please try again or call our direct line above.",
  "footerRights": "© 2026 WebKlienti · Performance-driven web design engineered for results",
  "faqLabel": "FAQ",
  "faqTitle": "Everything you need to know before we launch",
  "faqItems": [
    {
      "q": "How long does it realistically take to build a website?",
      "a": "We move fast because of our refined internal workflow. A business card website can go live from 3 business days, while larger websites take longer depending on their scope and features."
    },
    {
      "q": "Are there any recurring monthly developer fees?",
      "a": "No. You pay a single, transparent one-time fee for the complete development of the site. Once handed over, the website is 100% yours. Your only ongoing costs are standard domain registry and hosting (approx. 20–30 € per year) paid directly to the host provider — which we help you choose and configure completely free."
    },
    {
      "q": "How does the payment structure work?",
      "a": "Getting started is completely risk-free. Fill in the form, we'll do the analysis and send you the first visual concept within 24 hours — for free. If you say 'yes, we love it', we sign a contract and you pay a 50% deposit. The remaining 50% is due only when the website is finished, tested and ready to launch."
    },
    {
      "q": "Why are your prices significantly lower than traditional agencies?",
      "a": "We don’t fund expensive city-center offices, account executives, or corporate overheads. We are a lean, hyper-focused team of developers and conversion designers. By developing optimized internal templates and workflows, we cut out dead time and deliver premium assets for a fraction of market costs."
    },
    {
      "q": "What if I don't have professional text copy or high-res images?",
      "a": "We take care of that. Following a quick brief about your target market, we write high-converting marketing copy for you. If you don't possess custom business photography, we source licensed, high-tier premium stock images that match your brand identity perfectly."
    },
    {
      "q": "Who owns the finished website after deployment?",
      "a": "You do, entirely. Unlike closed platforms that lock you into monthly rental traps, we build independent code and hand over full administrative ownership. You have complete freedom over your asset."
    },
    {
      "q": "What happens if I don't like the free concept delivered in 24 hours?",
      "a": "You simply point out what needs adjustment, and we modify the layout. If you feel our direction doesn’t match your expectations at all, you can walk away instantly with zero obligations and zero cost. Since no money changes hands before approval, you assume no risk."
    }
  ],
  "guaranteeTitle": "100% Satisfaction Guarantee",
  "guaranteeText": "You see a functional visual layout of your future website before you spend a single cent.",
  "guaranteeBadges": [
    "✓ Strategic market analysis and concept within 24 hours",
    "✓ First custom draft completely free and without obligations",
    "✓ No hidden fees or long-term commitments"
  ],
  "cookieMsg": "This website utilizes cookies to ensure optimal functionality and monitor traffic metrics.",
  "cookieAccept": "Accept All",
  "cookieDecline": "Decline",
  "privacyLink": "Privacy Policy",
  "privacyTitle": "Personal Data Processing",
  "privacyContent": "Operator: WebKlienti, info@webklienti.com, +421 907 890 600\n\nWhat data we collect:\n• First name, last name, email address, phone number — exclusively via voluntary submission of the inquiry form.\n\nPurpose of processing:\nPreparation of the free design concept, calculating custom quotes, client communication, and fulfilling contract obligations.\n\nData retention:\nFor the duration of the communication or contractual agreement, and subsequently for the period required by applicable legal frameworks.\n\nYour rights:\nYou hold full rights to access your data, request corrections, demand complete erasure (the right to be forgotten), or restrict processing. Send all compliance requests to info@webklienti.com.\n\nAnalytics:\nWe deploy anonymized Google Analytics properties to monitor system health and evaluate ad campaign performance.\n\nEffective date: January 1, 2025",
  "statNote": "Every project is architected from line one of code for maximum core web vitals and speed. Zero slow, bloated marketplace themes.",
  "seoTitle": "Websites for Small Businesses from 149 € | WebKlienti",
  "seoDescription": "We build websites that help customers find you on Google. Live from 3 business days, free draft within 24 hours.",
  "seoUrl": "https://www.webklienti.com",
  "heroTag": "Performance Web Design for Small and Medium Enterprises",
  "heroCtaSec": "View Packages ↓",
  "trustStrip": [
    "We accept a maximum of 2 new projects per week to maintain pristine quality standards",
    "Clean code compiled strictly for lightning-fast deployment speeds",
    "Full strategic coverage for EU, UK, and global markets",
    "Built with a single metric in mind: Converting traffic into high-intent inbound inquiries"
  ],
  "consentLabel": "I agree to the processing of personal data for the purpose of preparing a non-binding proposal in accordance with the",
  "consentLink": "Privacy Policy",
  "consentError": "You must check the consent box to submit an inquiry successfully."
};

export default en;
